<template>
    <div class="col text-right">
    <div class="diagram" ref="travels" :id=id>
    </div>
    </div>
</template>

<script>
    import LocationTimeBarSpec from '../vega-spec/locationtime-bars.v.json'
    import embed from 'vega-embed'
    import _ from 'lodash'

    export default {
        name: "LocationTimeBars",
        props: ["data", "items", "filter",  "id"],
        data() {
            return {
                spec: {}
            }
        },
        watch: {
            spec(v) {
                if (v) this.draw()
            },
            data(v) {
                if(!this.filter){
                    this.load(v);
                    this.draw();
                }
            },
            items(v){
                this.update(v);
                this.draw()
            }
        },
        mounted: function () {
            this.spec = JSON.parse(JSON.stringify(LocationTimeBarSpec));
            this.updateWidth(this.$refs.travels.clientWidth-50);
            this.filter && this.update(this.items);
            !this.filter && this.load(this.data);
        },
        methods: {
            updateWidth(w){
                this.spec["width"] = w;
            },
            async draw() {
                if((!this.filter) || (this.items && this.items.size>0)) {
                    await embed('#' + this.id, this.spec, {actions: false}).catch(err => console.error(err));
                }
            },
            load(v) {
                if((!this.filter) || (this.items && this.items.size>0)) {
                    this.spec["data"][0]["values"] = _.cloneDeep(v);
                }
            },
            update(v) {
                this.load(this.data.filter(d => v.has(d.Source )));
                this.draw();
            }
        }
    }
</script>

<style scoped>
</style>


